import { KeyValuePipe, NgClass } from '@angular/common';
import { Component } from '@angular/core';

import { ISixPackOptionRow } from '../betting-insights/betting-insights-component-loader.service';
import { BetBuilderOptionComponent } from './bet-builder-option.component';
import { MarketHelpComponent } from './market-help/market-help.component';
import { OptionGroup } from './option-group.service';
import { OptionGroupTeamStatisticsService } from './player-statistics/option-group-team-statistics.service';
import { SixPackOptionGroupComponent } from './six-pack-option-group.component';

@Component({
    selector: 'ms-bet-builder-six-pack',
    templateUrl: './bet-builder-six-pack.component.html',
    imports: [NgClass, KeyValuePipe, MarketHelpComponent, BetBuilderOptionComponent],
    providers: [OptionGroupTeamStatisticsService],
})
export class BetBuilderSixPackComponent extends SixPackOptionGroupComponent {
    private maxParticipants = 2;

    protected override getOptionRows(optionGroups: OptionGroup[]): ISixPackOptionRow[] {
        return [...new Array(this.maxParticipants)].map((value, index) => ({
            player: '',
            columns: this.getOptionRowColumns(optionGroups, (options) => options[index]),
        }));
    }

    protected override getTupleClass(): string {
        const colCount = this.optionRows.length > 0 ? this.optionRows[0].columns.size : 0;
        switch (colCount) {
            case 2:
                return 'double';
            case 3:
                return 'triple';
            case 4:
                return 'quadruple';
            default:
                return '';
        }
    }
}
